exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nuxt-progress{position:fixed;top:0;left:0;right:0;height:100vh;width:0;opacity:1;transition:width .1s,opacity .4s;background-color:#001517;z-index:999999\n}\n.nuxt-progress.nuxt-progress-notransition{transition:none\n}\n.nuxt-progress-failed{background-color:red\n}", ""]);

// exports
